module.exports = "<dx-popup title=\"Podgląd zawiadomienia\"\n          [(visible)]=\"isPopupVisible\">\n    <div class=\"wrapper\"\n         *dxTemplate=\"let data of 'content'\">\n        <dx-scroll-view class=\"scroll\">\n            <div class=\"content\"\n                 [innerHTML]=\"resultView | safeHtml\"></div>\n        </dx-scroll-view>\n    </div>\n</dx-popup>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/single-view-custom/single-view-custom.component.html
// module id = ./src/app/components/single-view-custom/single-view-custom.component.html
// module chunks = main